import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class TimezoneHttpInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    httpRequest = httpRequest.clone({ setHeaders: { "KreditorGMTZone": timeZone }});
    return next
      .handle(httpRequest)
      .pipe(map(event => event));
  }

}
